import * as React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
} from "@mui/material";

export default function TableApiAcessStats({
  columns = [],
  rows = [],
  page = 1,
  pageSize = 10,
  lastPageNumber = 0,
  nextPage,
  previousPage,
  loading = false,
  dense = false,
  sx,
}) {
  const onPageChange = (e, newPage) => {
    if (newPage > page) {
      nextPage?.();
    } else if (newPage < page) {
      previousPage?.();
    }
  };

  return (
    <TableContainer
      component={Paper}
      elevation={1}
      sx={{ borderRadius: 3, overflow: "hidden", ...sx, border: "1px solid" }}
    >
      <Box position="relative" sx={{ height: 12, bgcolor: "#7C3AED" }}></Box>

      <Table
        size={dense ? "small" : "medium"}
        aria-label="log table"
        sx={{
          "& th, & td": {
            borderBottom: "1px solid",
            borderColor: "divider",
          },
          "& tbody tr:last-child td": { borderBottom: 0 }, // bỏ đường cuối

          "& th + th, & td + td": {
            borderLeft: "1px solid",
            borderColor: "divider",
          },

          "& thead th": {
            fontWeight: 700,
            backgroundColor: "#F5F5F5",
          },
        }}
      >
        <TableHead>
          <TableRow>
            {columns.map((col, i) => (
              <TableCell
                key={i}
                align={col.align || "left"}
                sx={{
                  fontWeight: 700,
                  backgroundColor: "#F5F5F5",
                }}
              >
                {col.headerName ?? ""}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={Math.max(columns.length, 1)}
                align="center"
                sx={{ py: 4 }}
              >
                {loading ? "Loading..." : "No data"}
              </TableCell>
            </TableRow>
          ) : (
            rows.map((row, idx) => (
              <TableRow
                key={row.id ?? `${page}-${idx}`}
                hover
                sx={{
                  "& td:first-of-type": {
                    backgroundColor: "#F5F5F5",
                  },
                }}
              >
                {columns.map((col, ci) => {
                  if (col.field === "") {
                    return (
                      <TableCell key={ci} sx={{ width: 56 }}>
                        {idx + (page - 1) * pageSize + 1}
                      </TableCell>
                    );
                  }
                  const value = row[col.field];
                  return (
                    <TableCell
                      key={ci}
                      align={col.align || "left"}
                      sx={{
                        whiteSpace: col.nowrap ? "nowrap" : undefined,
                        ...(ci === 4 && {
                          maxWidth: "40%",
                          width: "40%",
                          wordBreak: "break-all",
                        }),
                      }}
                    >
                      {col.render ? col.render(value, row, idx) : value}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>

      <TablePagination
        component="div"
        rowsPerPageOptions={[]}
        labelRowsPerPage=""
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={pageSize}
        labelDisplayedRows={({ page }) => `Page ${page}/${lastPageNumber}`}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      />
    </TableContainer>
  );
}
